export type AbTestTrafficSplitType = (typeof abTestTrafficSplitTypes)[number]

export const abTestTrafficSplitTypes = ['sessionStorage', 'localStorage', 'pageView'] as const
